import { render, staticRenderFns } from "./RightItem.vue?vue&type=template&id=a010e3e2&scoped=true"
import script from "./RightItem.vue?vue&type=script&lang=js"
export * from "./RightItem.vue?vue&type=script&lang=js"
import style0 from "./RightItem.vue?vue&type=style&index=0&id=a010e3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a010e3e2",
  null
  
)

export default component.exports